import * as React from 'react';
import { setMemberNameFilter } from '../actions';
import { directoryDispatch } from '../affiliate-directory';

interface IDirectoryFiltersName
{
  selectedNameFilter: string
}

class DirectoryFiltersName extends React.Component<IDirectoryFiltersName, any>{

  constructor(props)
  {
    super(props);
  }

  sendAction(e)
  {
    directoryDispatch()(setMemberNameFilter(e.target.value));
  }

  clearFilter(e)
  {
      directoryDispatch()(setMemberNameFilter(''));
  }

  render()
  {
    let setMemberName = this.sendAction.bind(this);

    return (
      <div className="filter-option">
        <label className="affiliate-filter-label" htmlFor="affiliate-name">Name</label>
        <em className="affiliate-filter-reset"><button onClick={this.clearFilter.bind( this )}> Clear</button></em>
        <input type="text" name="affiliate-name" id="affiliate-name" className="affiliate-filter-item" placeholder="First and Last Name" value={this.props.selectedNameFilter} onChange={setMemberName} />
      </div>
    )
  }
}

export default DirectoryFiltersName;


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/affiliate-directory/filters/directory-filters-name.tsx